export default __webpack_public_path__ + "static/policies-hero-bc14e1242dda9aabe6950879d2a2cb5f.jpg";